(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageController', RcopiaDosageController);

    RcopiaDosageController.$inject = ['$scope', '$state', 'RcopiaDosage', 'RcopiaDosageSearch'];

    function RcopiaDosageController ($scope, $state, RcopiaDosage, RcopiaDosageSearch) {
        var vm = this;

        vm.rcopiaDosages = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaDosage.query(function(result) {
                vm.rcopiaDosages = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaDosageSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaDosages = result;
            });
        }    }
})();
